// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import styled from 'styled-components';

import PrintingCard from 'common/modules/printing/styles/PrintingCard';
import { Metric, MetricTitle, MetricNumber } from 'common/modules/printing/styles/Metric';
import { Numeric } from 'common/components/Number';

import { convertSeconds } from '../../../metrics/domain/TimeResolution';
import type { SalesFlyer } from '../../domain/sales';

const TopSpacedPrintingCard = styled(PrintingCard)`
  margin-top: ${({ theme }) => theme.metrics.margin}px
`;

type Props = {
  flyer: SalesFlyer,
  t: any,
};

function SalesFlyerPrintingSummary({ flyer, t }: Props) {
  return (
    <React.Fragment>
      <PrintingCard>
        <Metric>
          <MetricTitle>{t('averageWeeklyReach')}</MetricTitle>
          <MetricNumber>
            {flyer.averageReach && <Numeric roundAt={0} value={flyer.averageReach} />}
            {!flyer.averageReach && t('na')}
          </MetricNumber>
        </Metric>
        <Metric>
          <MetricTitle>{t('averageWeeklyHoursOfListening')}</MetricTitle>
          <MetricNumber>
            {flyer.averageListeningTime && <Numeric roundAt={2} value={convertSeconds(flyer.averageListeningTime, 'HOURS')} />}
            {!flyer.averageListeningTime && t('na')}
          </MetricNumber>
        </Metric>
        <Metric>
          <MetricTitle>{t('averageWeeklyHoursOfListeningPerPerson')}</MetricTitle>
          <MetricNumber>
            {flyer.averageListeningTimePerPerson && <Numeric roundAt={2} value={convertSeconds(flyer.averageListeningTimePerPerson, 'HOURS')} />}
            {!flyer.averageListeningTimePerPerson && t('na')}
          </MetricNumber>
        </Metric>
      </PrintingCard>

      <TopSpacedPrintingCard>
        <Metric>
          <MetricTitle>{t('bestWeeklyReach')}</MetricTitle>
          <MetricNumber>
            {flyer.reach && <Numeric roundAt={0} value={flyer.reach} />}
            {!flyer.reach && t('na')}
          </MetricNumber>
        </Metric>
        <Metric>
          <MetricTitle>{t('bestWeeklyTotalListening')}</MetricTitle>
          <MetricNumber>
            {flyer.listeningTime && <Numeric roundAt={2} value={convertSeconds(flyer.listeningTime, 'HOURS')} />}
            {!flyer.listeningTime && t('na')}
          </MetricNumber>
        </Metric>
        <Metric>
          <MetricTitle>{t('bestWeeklyTotalListeningPerPerson')}</MetricTitle>
          <MetricNumber>
            {flyer.listeningTimePerPerson && <Numeric roundAt={2} value={convertSeconds(flyer.listeningTimePerPerson, 'HOURS')} />}
            {!flyer.listeningTimePerPerson && t('na')}
          </MetricNumber>
        </Metric>
      </TopSpacedPrintingCard>
    </React.Fragment>
  );
}

export default translate('sales')(SalesFlyerPrintingSummary);



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/components/printing/SalesFlyerPrintingSummary.js